import React from 'react';


class CopyToClipboard extends React.Component {

    constructor(props) {
        super(props);
        this.state = { copied: false };
        this.copyToClipboard = this.copyToClipboard.bind(this);
    }

    copyToClipboard(e) {
        e.preventDefault();
        const { itemId } = this.props;
        navigator.clipboard.writeText(itemId).then(() => {
            this.setState({ copied: true });
            setTimeout(() => this.setState({ copied: false }), 1500);
        });
    }

    render() {
        const { copied } = this.state;
        const { itemId, className = '', tooltip = 'Vörunúmer afritað', children, ...rest } = this.props;
        return (
            <span className={`copy-wrapper position-relative ${className}`}{...rest} >
                <a className='product-num-id' href={`/vara/${itemId}`} onClick={this.copyToClipboard}> {children || itemId}</a>
                <span className={`copied-tooltip position-absolute ${copied ? 'is-visible' : ''}`}>
                    {tooltip}
                </span>
            </span>
        )
    }
}
export default CopyToClipboard;
